import { loginApi } from '@/api/api.js'
/*
 * 语言偏好的唯一来源：切换器读写、http 拦截器注入 X-Locale 都从这里取值，
 * 新增语言只需往 languageList 里加一项
 */

// localStorage 中的键名，值为 JSON 串，存储结构 { "userLanguage": "en" }
const I18N_CONFIG_KEY = "i18n_config";

// 手改或旧版本残留的非法 JSON 会让 parse 抛错，兜底成空对象，读写都不至于崩
const getI18nConfig = () => {
  try {
    return JSON.parse(localStorage.getItem(I18N_CONFIG_KEY)) || {};
  } catch (e) {
    return {};
  }
};

export const DEFAULT_LANGUAGE = "zh-CN";

// label 用各语言的自称，避免用户误切到看不懂的语言后找不回来
// 数据结构与后端 getLanguageList 接口返回一致（小写字段 + id/isenable/ord）
export const locaLanguageList = [
    { "id": 1, "code": "zh-CN", "name": "简体中文", "isenable": 1, "ord": 1 },
    { "id": 2, "code": "zh-TW", "name": "繁體中文", "isenable": 1, "ord": 2 },
    { "id": 3, "code": "en", "name": "English", "isenable": 1, "ord": 3 },
    { "id": 4, "code": "ms", "name": "Bahasa Malaysia", "isenable": 1, "ord": 4 },
    { "id": 5, "code": "th", "name": "ภาษาไทย", "isenable": 1, "ord": 5 },
    { "id": 6, "code": "es", "name": "Español", "isenable": 1, "ord": 6 },
    { "id": 7, "code": "fr", "name": "Français", "isenable": 1, "ord": 7 },
    { "id": 8, "code": "ru", "name": "Русский", "isenable": 1, "ord": 8 }
];

// 语言列表全程只取一次：首次请求的 Promise 被缓存复用。
// 这既省掉重复请求，也是一道兜底——调用方若在请求拦截器里间接触到这里，不会递归发起新请求
let languageListPromise = null;

// 获取语言列表，接口异常或返回空时退回本地内置列表
export const getLanguageList = () => {
  if (languageListPromise) return languageListPromise;
  languageListPromise = loginApi
    .getLanguageList()
    .then(({ RetCode, RetObject }) =>
      RetCode === 0 && RetObject && RetObject.length ? RetObject : locaLanguageList
    )
    .catch(() => locaLanguageList);
  return languageListPromise;
};

/*
 * 引导阶段一次性取回「当前语言 + 语言列表」，仅 main.js 调用。
 * 运行期需要当前语言时读 i18n.locale（同步、响应式），不要再调这里——本函数带网络请求
 */
export const getLanguage = () => {
  const language = getI18nConfig().userLanguage;
  return getLanguageList().then(languageList => ({
    // 缓存里存的是 code，必须与 code 比对；比 name 会恒为 false 而把用户选择重置成默认语言
    language: languageList.some(item => item.code === language) ? language : DEFAULT_LANGUAGE,
    languageList
  }));
};

// 基于已有配置合并写回，后续往 i18n_config 里加别的字段时不会被语言切换覆盖掉
export const setLanguage = language =>
  localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({ ...getI18nConfig(), userLanguage: language }));


// WEBPACK FOOTER //
// ./src/extra/language.js